import { PlanState } from "api/modules/Plans/modules/state";
import { AuthState, Credentials } from "auth";
import { LayoutState } from "layouts/AppLayout/modules/state";
import intersection from "lodash/intersection";
import { useSelector } from "react-redux";
import { AdminState } from "routes/Admin/modules";
import { AppPage, AppPagesMap, AppsMap, AppState } from "routes/App/modules/state";
import { OrgState, UserSeries } from "routes/Organization/modules";

export { AuthState, Credentials };
export { LayoutState };
export { AdminState };
export { AppPagesMap, AppPage, AppsMap, AppState };
export { OrgState, UserSeries };


export type State = {
    admin: AdminState;
    app: AppState;
    auth: AuthState;
    layout: LayoutState;
    org: OrgState;
    plan: PlanState;
    // Deprecating
    smapi: any;
};

export function isLoading(state: State, action: string | string[]): boolean {
    if (typeof action === "string") {
        return state.layout.loading.indexOf(action) >= 0;
    }

    return intersection(state.layout.loading, action).length > 0;
}

export function useIsLoading(action: string | readonly string[]): boolean {
    const state = useSelector<State, LayoutState>(state => state.layout);
    if (typeof action === "string") {
        return state.loading.indexOf(action) >= 0;
    }

    return intersection(state.loading, action).length > 0;
}

export function useErrorMap(key: string): Error {
    const state = useSelector<State, AppState>(state => state.app);
    return state.errorMap[key];
}
